import { render } from "./CreatePaymentLiquidation2.vue?vue&type=template&id=9a569354"
import script from "./CreatePaymentLiquidation2.vue?vue&type=script&lang=js"
export * from "./CreatePaymentLiquidation2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__